<template>
    <div class="context common_table_view">
        <div class="header" ref="header">
            <div class="search search_box">
                <!--
                <el-form :model="searchForm" class="search_form" inline size="small">
                    <el-form-item label="月份:">
                        <el-date-picker
                                v-model="searchForm.month"
                                type="month"
                                placeholder="选择月"
                                value-format="yyyy-MM"
                                @change="getTableData()"
                        >
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                        <div class="search_btn">
                            <el-button type="primary" @click="getTableData()">
                                搜索
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>-->
            </div>
            <div class="btn_box">
                <el-button type="primary" @click="addList" size="small">
                    添加排除清单
                </el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData" stripe width="100%" height="100%">
                <el-table-column
                        v-for="(item, index) in columnData"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width"
                        :formatter="item.formatter"
                        :fixed="item.fixed"
                        show-overflow-tooltip
                        :key="index"
                ></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <!-- <span class="table_btn"
                                          @click="editRow(scope.row)">
                                        <i class="el-icon-edit"></i>
                                        编辑
                                    </span> -->
                        <span class="table_del_btn" @click="delRow(scope.row)">
              <i class="el-icon-delete"></i>
              删除
            </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottom_page" ref="bottom_page">
            <page-view
                    @getTableList="handleCurrentChange"
                    :currentPage="currentPage"
                    :pageSize="pageSize"
                    :total="total"
            ></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "@/global/utils";
    import configs from '../configs'

    export default {
        name: "tableView",
        data() {
            const drugCodeFormatter = (row, column, cellValue, index) => {
                let f_l = this.drug_code_list.find((l) => l.drug_code == cellValue);
                if (f_l) {
                    return f_l.name;
                }
                return "";
            };
            const sourceFormatter = (row, column, cellValue, index) => {
                let f_l = configs.classification_list.find((l) => l.value == cellValue);
                if (f_l) {
                    return f_l.name;
                }
                return "";
            };
            return {
                searchForm: {
                    month: "",
                },
                cityList: [],
                cascader_props: {
                    expandTrigger: "hover",
                    value: "name",
                    label: "name",
                    children: "city_list",
                },

                tableData: [],
                columnData: [
                    {label: "省", prop: "province"},
                    {label: "市", prop: "city"},
                    {label: "医院", prop: "name", width: 300},
                    {label: "使用药物", prop: "drug_code", formatter: drugCodeFormatter},
                    {label: "来源", prop: "source", formatter: sourceFormatter},
                ],
                total: 0,
                currentPage: 1,
                pageSize: 50,
            };
        },
        computed: {
            ...mapState("comInformationData", ["drug_code_list"]),
        },
        mounted() {
            this.getTableData();
            this.$eventBus.$on("pollPort",() =>{
                this.getTableData()
            })
        },
        beforeDestroy() {
            this.$eventBus.$off('pollPort');
        },
        methods: {
            ...mapMutations("manageData", {
                setDoctorData: "setDoctorData",
            }),
            addList() {
                // this.setDoctorData(null);
                this.$emit("changeTopTab", "addView");
            },
            editRow(row) {
                this.setDoctorData(row);
                this.$emit("changeTopTab", "addView");
            },

            delRow(row) {
                this.$confirm("确定删除该清单么？")
                    .then(() => {
                        let params = {
                            list_id: row.list_id,
                        };
                        this.httpGet(`/visit_list/delete`, params).then((res) => {
                            this.$message.success("删除成功！");
                            if (this.tableData.length === 1) {
                                let page = this.currentPage === 1 ? 1 : this.currentPage - 1;
                                this.getTableData(page);
                            } else {
                                this.getTableData(this.currentPage);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },

            handleCurrentChange(val) {
                this.getTableData(val);
            },
            getTableData(v = 1) {
                console.log("get_data");
                let params = {
                    // month: this.searchForm.month,
                    page: v,
                    page_size: this.pageSize,
                    is_excluded: 2
                };
                this.httpGet("/visit_list/list", params).then((res) => {
                    this.tableData = res.data.result;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v;
                    });
                });
            },
        },
    };
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>